import { USER_ENDPOINTS } from "./endpoints";
import {
  ADUsers,
  CreatePositionBody,
  Position,
  Response,
  UpdateUserBody,
  UpdateUserResponse,
  UserProps,
} from "../../types";
import { workflowInstance_V2 } from "../api";
import { callApi, callWorkflowGET, callWorkflowPOST, callWorkflowPUT } from "../generic";

export const getUsersByQuery = async (
  query?: string,
  limit = 10,
): Promise<ADUsers[]> =>
  callApi(() =>
    workflowInstance_V2.get(
      query
        ? `${USER_ENDPOINTS.USER_SEARCH}?query=${encodeURIComponent(
            query,
          )}&limit=${limit}`
        : `${USER_ENDPOINTS.USER_SEARCH}?limit=${limit}`,
    ),
  );

export const getPositions = async (): Promise<Position[]> =>
  callWorkflowGET<Position[]>(USER_ENDPOINTS.POSITIONS);

export const getPositionsByQuery = async (
  setObject: (obj: Response<Position[]>) => void,
) => {
  try {
    setObject({ data: [], loading: true, error: false });
    const positions = await getPositions();
    setObject({ data: positions, loading: false, error: false });
  } catch {
    setObject({ data: [], loading: false, error: true });
  }
};

export const createPosition = async (name: string): Promise<Position> =>
  callWorkflowPOST<Position, CreatePositionBody>(USER_ENDPOINTS.POSITIONS, {
    name,
  });

export const updateUser = async (
  userId: number,
  body: UpdateUserBody,
): Promise<UpdateUserResponse> =>
  callWorkflowPUT<UpdateUserResponse, UpdateUserBody>(
    USER_ENDPOINTS.USER_BY_ID(userId),
    body,
  );

export const getUserInfo = async (): Promise<UserProps> =>
  callApi(() => workflowInstance_V2(USER_ENDPOINTS.USER_ME));
